import { Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { DashboardLayout } from '@/layouts/DashboardLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { AdminRoute } from '@/components/common/AdminRoute';

import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';

import { UsersPage } from '@/pages/users/UsersPage';
import { OnboardingPage } from '@/pages/onboarding/OnboardingPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { AnalyticsPage } from '@/pages/analytics/AnalyticsPage';
import { ReportsPage } from '@/pages/analytics/ReportsPage';
import { RealtimePage } from '@/pages/analytics/RealtimePage';
import { SettingsPage } from '@/pages/settings/SettingsPage';
import { SimpleFormPage } from '@/pages/SimpleFormPage';
import { ComprehensiveFormPage } from '@/pages/ComprehensiveFormPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import Prompt from './pages/prompt/Prompt';
import { CreateEventPage } from './pages/form/CreateEventPage';
import { EventListPage } from './pages/eventListPage/EventListPage';
import CertificatePage from './pages/certificatePage/CertificatePage';
import CreateCertificatePage from './pages/createCertificatePage/CreateCertificatePage';
import ChangePassword from './pages/auth/ChangePassword';
import CertificateUsersPage from './pages/auth/certificateUsersPage/CertificateUsersPage';
import CertificateEventListPage from './pages/certificateEventListPage/CertificateEventListPage';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/create-event" element={<CreateEventPage />} />
          <Route path="/event-list" element={<EventListPage />} />
          <Route path="/certificate-list" element={<CertificateEventListPage />} />
          <Route path="/certificates" element={<CertificatePage />} />
          <Route path="/create-certificate" element={<CreateCertificatePage />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/certificates/:id/users" element={<CertificateUsersPage />} />
          {/* <Route path="/training" element={<TrainingPage />} /> */}
          <Route path="/upload-prompt" element={<Prompt />} />
          {/* <Route path="/file-history" element={<FileHistoryPage />} /> */}
          {/* <Route path="/prompt-history" element={<PromptHistory />} /> */}
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />

          {/* Analytics Routes */}
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/analytics/reports" element={<ReportsPage />} />
          <Route path="/analytics/realtime" element={<RealtimePage />} />

          {/* Settings Routes */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Form Examples */}
          <Route path="/forms" element={<SimpleFormPage />} />
          <Route path="/forms/comprehensive" element={<ComprehensiveFormPage />} />

          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
